import { render } from "./SurveiKepuasan.vue?vue&type=template&id=67cb6c06&scoped=true"
import script from "./SurveiKepuasan.vue?vue&type=script&lang=js"
export * from "./SurveiKepuasan.vue?vue&type=script&lang=js"

import "./SurveiKepuasan.vue?vue&type=style&index=0&id=67cb6c06&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cb6c06"]])

export default __exports__